import { render, staticRenderFns } from "./CreateReportStudent.vue?vue&type=template&id=5a5213e5&scoped=true"
import script from "./CreateReportStudent.vue?vue&type=script&lang=js"
export * from "./CreateReportStudent.vue?vue&type=script&lang=js"
import style0 from "./CreateReportStudent.vue?vue&type=style&index=0&id=5a5213e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5213e5",
  null
  
)

export default component.exports